// @file Composable for remote slideshow controls over Realtime (Brahms)
import { useSlideshowPages } from '@@/vuecomposables/slideshow_pages'

export const useSlideshowRemote = (): {
  handleIncomingGoToSlide: (slideNumber: number) => void
  handleIncomingNextSlide: () => void
  handleIncomingPreviousSlide: () => void
} => {
  const { onNext, onPrevious, goToPage } = useSlideshowPages()
  const isRenderingSlideshow = (): boolean => {
    try {
      return typeof window !== 'undefined' && window.location?.pathname?.includes('slideshow') === true
    } catch {
      return false
    }
  }

  const handleIncomingGoToSlide = (slideNumber: number): void => {
    if (typeof slideNumber !== 'number' || Number.isNaN(slideNumber)) return
    if (!isRenderingSlideshow()) return
    goToPage(slideNumber)
  }

  const handleIncomingNextSlide = (): void => {
    if (!isRenderingSlideshow()) return
    onNext()
  }

  const handleIncomingPreviousSlide = (): void => {
    if (!isRenderingSlideshow()) return
    onPrevious()
  }

  return {
    handleIncomingGoToSlide,
    handleIncomingNextSlide,
    handleIncomingPreviousSlide,
  }
}

export default useSlideshowRemote
